import { OnInit, Component, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    templateUrl: './dialogHelp.html',
    styleUrls: ['./dialogHelp.css']
})
export class DialogHelp implements OnInit {

    public static async openDialog(matDialog: MatDialog, helperPage: string) {
        if (!helperPage) return undefined;
        return matDialog.open(DialogHelp, { width: "75%", data: helperPage, panelClass: 'arma-dialog-blue'}).afterClosed().toPromise();
    }

    constructor(
        public mDialogRef: MatDialogRef<DialogHelp>,
        @Inject(MAT_DIALOG_DATA) private mHelperPage: string
    ) { }

    ngOnInit(): void {
        if (!this.helperPage)
            this.mDialogRef.close();
    }

    get helperPage(): string {
        return this.mHelperPage
    }

    get CST_DIALOG_HELP_PAGE(): any {
        return CST_DIALOG_HELP_PAGE;
    }
}

export const CST_DIALOG_HELP_PAGE = {
    CONNECTION_HELP: "CONNECTION_HELP",
    PRINTER_HELP: "PRINTER_HELP"
}